import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HardHat, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Field } from "../components/common";
import { useAuth } from "../lib/auth";
import { errMsg } from "../lib/api";

const HERO = "/eti-logo.png";

function useLoginForm() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e?.preventDefault();
    setLoading(true);
    setError("");
    try {
      const u = await login(email, password);
      toast.success(`Benvenuto, ${u.first_name}`);
      nav("/");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };
  return { email, setEmail, password, setPassword, loading, error, submit };
}

function LoginHero() {
  return (
    <div className="relative hidden lg:flex items-center justify-center overflow-hidden bg-white p-12" data-testid="login-hero">
      <div className="absolute top-0 inset-x-0 h-2 hazard-stripe opacity-80" />
      <img src={HERO} alt="Enterprise Technology Innovation srl - Costruzioni tecnologiche" className="w-full max-w-2xl h-auto object-contain" data-testid="login-hero-logo" />
    </div>
  );
}

function LoginBrand() {
  return (
    <div className="flex items-center gap-3 mb-10">
      <div className="h-12 w-12 rounded-xl bg-amber-500 flex items-center justify-center text-slate-950">
        <HardHat className="h-7 w-7" strokeWidth={2.4} />
      </div>
      <div>
        <h1 className="font-heading text-2xl font-extrabold tracking-tight" data-testid="login-app-name">
          CANTIERE <span className="text-amber-400">MANAGER</span> PRO
        </h1>
        <p className="text-sm text-muted-foreground">Gestione intelligente di operai, mezzi e cantieri</p>
      </div>
    </div>
  );
}

export default function Login() {
  const { email, setEmail, password, setPassword, loading, error, submit } = useLoginForm();
  return (
    <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr]">
      <LoginHero />
      <div className="flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-md fade-up">
          <LoginBrand />
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <Field label="Email">
              <Input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-12" data-testid="login-email-input" placeholder="nome@azienda.it" />
            </Field>
            <Field label="Password">
              <Input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-12" data-testid="login-password-input" placeholder="••••••••" />
            </Field>
            {error && <div className="rounded-lg border border-red-600 bg-red-950/60 px-3 py-2 text-sm text-red-200" data-testid="login-error">✕ {error}</div>}
            <Button type="submit" disabled={loading} className="w-full h-12 text-base font-bold" data-testid="login-submit-button">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Accedi"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
